import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import styles from './ModalContent.module.scss';

export const ModalContent: React.FC<PropsWithChildren<{ className?: string }>> = ({
  className,
  children,
  ...rest
}) => {
  return (
    <div
      className={classNames('background-white w-100', styles['modal-content'], className)}
      {...rest}
    >
      {children}
    </div>
  );
};
